import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example">
                <h1>
                  Custom Software Development <span>Miami</span>
                </h1>
              </div>
              <p className="main_para">
                We're a leading custom software development company in Miami,
                specializing in developing customized solutions to meet the
                unique needs of our clients. Our software developers Miami are
                experts in utilizing the latest technologies to deliver
                top-notch custom solutions that drive business growth. Software
                development Miami is booming, powered by the city's varied
                economy, strategic location, and supportive tech community, and
                we assist you thrive by delivering cutting-edge software
                solutions.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
